const buildQueryString = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }

    if (typeof value === 'string') {
      const normalizedValue = value.trim();

      if (!normalizedValue) {
        return;
      }

      query.set(key, normalizedValue);
      return;
    }

    query.set(key, String(value));
  });

  return query.toString();
};

export { buildQueryString };
